module.exports = __webpack_public_path__ + "img/74.4bd584ee.jpg";